import { tvpil } from '../compat/tvpil';
import { getFavoriteDictionary } from '../favorite/getFavoriteDictionary';
import { getLastWatched } from '../lastWatched/getLastWatched';
import { getMostWatched } from '../mostWatched/getMostWatched';

import { composeChannels } from './composeChannels';
import { getChannelAssetsQueryData, getChannelCollectionQueryData, getEntitledChannelsQueryData } from './queryData';
import { getLimit } from './utils';

export type GetChannelsArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export function getChannels({ referenceId, pageReferenceId }: GetChannelsArgs) {
  const channelAssetsData = getChannelAssetsQueryData();
  const entitledChannelsData = getEntitledChannelsQueryData();
  const channelCollectionData = getChannelCollectionQueryData(referenceId);
  const favoriteChannelsData = getFavoriteDictionary();
  const lastWatchedData = getLastWatched({ referenceId, pageReferenceId });
  const mostWatchedData = getMostWatched({ referenceId });

  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!channelAssetsData || !entitledChannelsData || !channelCollectionData || !favoriteChannelsData) {
    return undefined;
  }

  return composeChannels({
    channelAssetsMap: channelAssetsData.channelMap,
    channelCollection: channelCollectionData.collection,
    entitledChannels: entitledChannelsData,
    favoriteChannels: favoriteChannelsData.favoritePositions,
    lastWatched: lastWatchedData,
    limit: category ? getLimit(category) : undefined,
    mostWatched: mostWatchedData,
    orderBatches: category?.epgProperty?.orderBatches,
  });
}
